var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCkChevronLeftWhite24 = function SvgCkChevronLeftWhite24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.91 7.91L14.5 6.5L8.5 12.5L14.5 18.5L15.91 17.09L11.33 12.5L15.91 7.91Z",
    fill: "white"
  })));
};
export { SvgCkChevronLeftWhite24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjkxIDcuOTFMMTQuNSA2LjVMOC41IDEyLjVMMTQuNSAxOC41TDE1LjkxIDE3LjA5TDExLjMzIDEyLjVMMTUuOTEgNy45MVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";